import FlexPane from './_flex-pane.js'
import MenuRow from './_menu-row.js'
import GenericMarketContent from './_generic-market-content.js'
import RangeInput from './_range-input.js'
import Text from './_text.js'

export default {
  name: 'HandicapMarketContent',
  values: {
    incompatibleInplaySports: [
    ],
    isMainPivotDefault: true,
    minNumberOfMarkets: 5,
    container: {
      configSet: FlexPane,
      configValues: {
        itemSpacing: '16px',
        style: {
          flexDirection: 'column',
          padding: '8px',
        },
      },
    },
    categorySelector: {
      configSet: MenuRow,
      configValues: {
        style: {
          container: {
            padding: 0,
            width: '100%',
          },
        },
        item: {
          unselected: {
            style: {
              base: {
                flexGrow: 0,
                minWidth: '60px',
                padding: '0 4px',
              },
            },
          },
          selected: {
            style: {
              base: {
                flexGrow: 0,
                minWidth: '60px',
                padding: '0 4px',
              },
            },
          },
          indicator: {
            style: {
              base: {
                width: 'calc(100% - 8px)',
              },
            },
          },
        },
        buttonScrollPane: {
          contentContainer: {
            style: {
              _mobile_padding: 0,
            },
          },
        },
      },
    },
    genericMarketContent: {
      configSet: GenericMarketContent,
      configValues: {
        layoutDescriptors: {
          default: {
            selectionsHeaderContent: 'participant',
          },
        },
        container: {
          style: {
            padding: '0px',
          },
        },
      },
    },
    rangeInputContainer: {
      configSet: FlexPane,
      configValues: {
        itemSpacing: '8px',
        style: {
          flexDirection: 'column',
        },
      },
    },
    rangeInput: {
      configSet: RangeInput,
      configValues: {
        style: {
          input: {
            margin: '0',
          },
        },
      },
    },
    rangeInputMinMaxContainer: {
      configSet: FlexPane,
      configValues: {
        style: {
          justifyContent: 'space-between',
        },
      },
    },
    rangeInputLabel: {
      configSet: Text,
      configValues: {
        container: {
          flexGrow: '0',
        },
      },
    },
  },
  meta: {
    extendable: false,
  },
}
